module.exports = __webpack_public_path__ + "img/Bela-Urbina.fdedb965.jpg";